import React from "react";
import { useOutletContext } from "react-router-dom";
import { RiAddCircleLine, RiFileList3Line, RiLockLine } from "@remixicon/react";
import PageHeader from "../common/PageHeader";
import LinkList from "../common/LinkList";

export default function BidsHub() {
	const { summary } = useOutletContext() || {};

	const items = [
		{ to: "/bids/new", icon: RiAddCircleLine, label: "New bid request", text: "Request live bids from sellers near your location" },
		{
			to: "/orders",
			state: { tab: "bidRequest" },
			icon: RiFileList3Line,
			label: "Active bid requests",
			text: "Bids waiting on seller offers or your award",
			badge: summary?.bidRequests || null,
		},
		{ to: "/closed-market", icon: RiLockLine, label: "Closed market quotes", text: "Order at today's fixed price from your contracted seller" },
	];

	return (
		<div style={{ maxWidth: 720 }}>
			<PageHeader title="Bids" subtitle="Request, track and award fuel bids" />
			<LinkList items={items} />
		</div>
	);
}
